// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollToGameRvn_root__vsF0R","gameIcon":"ScrollToGameRvn_gameIcon__Buq08","gameLabel":"ScrollToGameRvn_gameLabel__Vq27e","scrollArrow":"ScrollToGameRvn_scrollArrow__xh_0N"};